export const DevToken = ({
    uid,
    apikey,
} = {}) => ({
    uid,
    apikey,
});